import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { IDownloadButton } from "../../../app/models/toolbar";
import { RootStoreContext } from "../../../app/stores/rootStore";
import ProtectedDownload from "../../common/ProtectedDownload";
import CustomDownloadButton from "./CustomDownloadButton";

interface IParams {
  url: string;
  button: IDownloadButton;
  contentId: number;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const renderSwitch = (param: string) => {
  switch (param) {
    case "original":
      return "far fa-file iconToolbarButton";
    case "pdf":
      return "far fa-file-pdf iconToolbarButton";
    case "watermark":
      return "far fa-file-pdf iconToolbarButton";
  }
};

const DownloadButton: React.FC<IParams> = ({
  url,
  button,
  contentId,
  isOpen,
}) => {
  const [singleTooltip, setIsSingleTooltip] = useState("");
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      {button.type === "custom" ? (
        <CustomDownloadButton
        button={button}
          disabled={button.disabled}
          inProgress={button.inProgress}
          url={url}
          contentId={contentId}
          isOpen={isOpen}
        />
      ) : (
      <>
        <div className="text-center mr-2 toolbarButton">
          <ProtectedDownload
            hasLoaderModal={true}
            url={url}
            children={
              <Button
                id={button.type}
                className={classNames(
                  "mr-2 w-100 h-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
                  `${theme!.toolbarIconColor}`
                )}
                color=""
                // color={!button.inProgress ? "light" : "secondary"}
                disabled={button.disabled}
                onMouseEnter={() => setIsSingleTooltip(button.type)}
                onMouseLeave={() => setIsSingleTooltip("")}
              >
                <i className={renderSwitch(button.type)}></i>
                <h6 className="textToolbarButton mb-0">
                  {t("toolbar_download_button")}
                </h6>
                {/* <h6 className="font-size-80 ">{button.type}</h6> */}
              </Button>
            }
          ></ProtectedDownload>
          <UncontrolledTooltip
            delay={0}
            placement="bottom"
            target={button.type}
            isOpen={isOpen || singleTooltip === button.type}
          >
            {button.type}
          </UncontrolledTooltip>
        </div>
        </>
      )}
    </>
  );
};

export default observer(DownloadButton);
